import { Ajax } from './../Core/Ajax';
import { Constants } from './../Core/Constants';

export class CatalogueProvider {

	static getSuggestions(text, success) {
		Ajax.get(Constants.Url.Suggestions, "searchString=" + text, (data) => {
			success(data);
		});
	}

	static getProductByIds(ids, success) {
		Ajax.post(Constants.Url.ProductIds, { ids: ids },(data) => {
			success(data);
		});
	}

	static getProductBuyWith(success) {
		Ajax.get(Constants.Url.CartAdditionalInfo, null, (data) => {
			success(data.buyWithProducts);
		});
	}
}
